import queryString from 'qs';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, find, set } from 'lodash';

import ShowReport from './ShowReport';

import config from '../configs/shows-config';

import * as queryActions from '../../actions/query-actions';
import * as showActions from '../../actions/show-actions';
import * as filtersActions from '../../actions/filters-actions';

import { getShow } from '../../reducers/show-reducer';
import { selectBenchmarks } from '../../reducers/filters-reducer';
import { getLooks } from '../../reducers/embed-reducer';
import {
  getInlineQueryResult,
  getInlineQueryResults,
  getInlineQueryStatus
} from '../../reducers/query-reducer';

const {
  looks: viewershipLooks,
  queries: viewershipQueries
} = config.SHOW_REPORT_FILTERS.showReportViewership;

const {
  looks: engagementLooks,
  queries: engagementQueries
} = config.SHOW_REPORT_FILTERS.showReportEngagement;

const {
  looks: anticipationLooks,
  queries: anticipationQueries
} = config.SHOW_REPORT_FILTERS.showReportAnticipation;

const {
  queries: affinityQueries
} = config.SHOW_REPORT_FILTERS.showReportAffinity;

const mapStateToProps = (state, ownProps) => {
  const showId = get(ownProps, 'match.params.showId', '');
  const show = getShow(showId, state);
  const query = queryString.parse(
    get(state, 'router.location.search', '').slice(1)
  );

  const benchmarks = selectBenchmarks(state);

  const findSelectedBenchmark = (bms, q) => {
    const bm = get(q, 'benchmark', null);
    const defaultBenchmark = find(bms, b => b.isDefault);

    if (bm) {
      return bm;
    } else if (defaultBenchmark) {
      return defaultBenchmark.uuid;
    }

    return null;
  };

  const getShowFilters = (filters, showId) => {
    const currentShowId = get(filters, 'fields.show.value');
    if (currentShowId && showId && currentShowId !== showId) {
      set(filters, 'fields.show.value', {
        label: '',
        value: showId
      });
    }
    return { ...filters };
  };

  return {
    viewershipLooks: getLooks(viewershipLooks, state),
    viewershipQueries: getInlineQueryResults(viewershipQueries, state),

    engagementLooks: getLooks(engagementLooks, state),
    engagementQueries: {
      ...getInlineQueryResults(engagementQueries, state),
      [config.SHOW_REPORT_FILTERS.memeListQuery.id]: getInlineQueryResult(
        config.SHOW_REPORT_FILTERS.memeListQuery.id,
        state
      )
    },

    anticipationLooks: getLooks(anticipationLooks, state),
    anticipationQueries: getInlineQueryResults(anticipationQueries, state),

    affinityQueries: getInlineQueryResults(affinityQueries, state),

    filters: getShowFilters(state.filters, showId),
    fetchMemesStatus: getInlineQueryStatus(
      config.SHOW_REPORT_FILTERS.memeListQuery.id,
      state
    ),

    show,
    selectedBenchmark: findSelectedBenchmark(benchmarks, query),
    benchmarks
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const showId = get(ownProps, 'match.params.showId', '');

  return {
    fetchShow: () => dispatch(showActions.getShowData(showId)),

    showId: get(ownProps, 'match.params.showId', ''),

    fetchMemes: screencapId =>
      dispatch(
        queryActions.runFormattedInlineQuery(
          config.SHOW_REPORT_FILTERS.memeListQuery.id,
          config.SHOW_REPORT_FILTERS.memeListQuery,
          {
            screencapId: {
              id: 'screencapId',
              value: { value: `${screencapId}` }
            }
          }
        )
      ),

    fetchComments: filters =>
      dispatch(
        queryActions.runInlineQuery(
          config.SHOW_REPORT_FILTERS.commentFeedQuery.id,
          config.SHOW_REPORT_FILTERS.commentFeedQuery,
          filters
        )
      ),

    updateEpisodeOptionsLoader: seasons => {
      dispatch(showActions.setEpisodeFilterOptions({ showId, seasons }));
    },

    loadAvailableSeasons: show => {
      return dispatch(filtersActions.loadShowSeasons(show.number_of_seasons));
    },

    filtersActions: bindActionCreators(filtersActions, dispatch),
    queryActions: bindActionCreators(queryActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowReport);
